module.exports = __webpack_public_path__ + "media/lan/LogoColor-d8960418.png";